<template>
  
</template>

<script>
    import router from "@/router";
    export default {
        name: "Redirect",
        mounted() {
            const pathName = window.location.pathname;

            if(pathName.includes("circle")) {
                const { id, parent_id } = this.$route.params;
                if (id && parent_id) {
                    router.replace({ path: `/circle/${parent_id}/child/${id}`});
                }
            }
        }
    }
</script>